<template>
  <div class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
    <h2 class="aoform__title">Моя максимальная защита</h2>
    <SelectInput
      text='ВЫБЕРИТЕ ПРОГРАММУ'
      name='program'
      :options="programs"
      v-model="selectedProgram" />
    <h3 class="aoform__title">Страхователь</h3>
    <ShortFields>
      <SelectInput
        text='ПОЛ'
        name='sex'
        :options="['Мужской','Женский']"
        v-model="client.sex" />
      <DateInput
        placeholder="01.01.1970"
        text='ДАТА РОЖДЕНИЯ'
        name='birthdate'
        v-model="client.birthdate"
        :validation="validations.birthdate"
        />
    </ShortFields>
    <TextInput placeholder="Иванов Иван Иванович" text='ФИО' name='fullname' v-model="client.fullname" :validation="(v)=>v?((v.split(' ').length < 3)? 'Заполните поле':''):''" :options="fullnameSuggest" :blurcondition="client.fullname.split(' ').length >= 3" :selectonly="true"/>
    <TextInput text='МЕСТО РОЖДЕНИЯ' name='birthplace' v-model="client.birthplace" 
        :options="birthplaceSuggest"/>
    <template v-if="programIndex > 0">
      <h3 class="aoform__title">Адрес имущества</h3>
      <TextInput text='Адрес' name='address' v-model="client.address.text" :options="addressSuggest" :forceError="addressValidation" :blurcondition="!addressValidation"/>
      <CheckboxInput :required="false" name='noflat' :light="true" v-model="client.address.noflat" descr='Отсутствует квартира'/>
    </template>
    <h3 class="aoform__title">Паспортные данные</h3>
    <ShortFields>
      <NumberInput 
        placeholder="12 34"
        text='Серия'
        name='p-series'
        mask='## ##'
        :filled="(v)=>v.length==5"
        v-model="client.passport.series"/>
      <NumberInput 
        text='Номер'
        placeholder="123 456"
        name='p-number'
        mask='### ###'
        :filled="(v)=>v.length==7"
        v-model="client.passport.number"/>
      <DateInput
        placeholder="01.01.2010"
        text='ДАТА ВЫДАЧИ'
        name='p-releasedate'
        v-model="client.passport.releasedate"
        :validation="validations.releasedate"
        />
    </ShortFields>
    <h3 class="aoform__title">Контактная информация</h3>
    <NumberInput text='НОМЕР ТЕЛЕФОНА'
                name='phonenumber'
                type='tel'
                :filled="(v)=>v.length==18"
                mask='+7 (###) ###-##-##'
                placeholder="+7 (123) 456-78-90"
                v-model="client.phonenumber" />
    <EmailInput text='E-MAIL'
                name='email'
                placeholder="my@email.com"
                v-model="client.email" />
    <CheckboxInput name='agreement' v-model="client.isAgree"
                  descr='Я ознакомился с Пользовательским соглашением, <a href="https://rosbankinsurance.ru/documents/politics_SGS.pdf" target="_blank"">политикой обработки персональных данных (ПД)</a>, <a href="https://rosbankinsurance.ru/documents/KID_DEFANCE_MMZ.docx" target="_blank">условиями страхования, ключевым информационным документом (КИД)</a> и даю согласие на обработку ПД.'/>
    <FormBtn :disabled="(!allFilled && validationEnabled) || block" @click.native="sendForm">Оформить полис</FormBtn>
  </div>
</template>

<script>
import SelectInput from '@/components/SelectInput.vue'
import FormTitles from '@/mixins/FormTitles.vue'
import TextInput from '@/components/TextInput.vue'
import ShortFields from '@/components/ShortFields.vue'
import DateInput from '@/components/DateInput.vue'
import NumberInput from '@/components/NumberInput.vue'
import EmailInput from '@/components/EmailInput.vue'
import CheckboxInput from '@/components/CheckboxInput.vue'
import FormBtn from '@/components/FormBtn.vue'
import axios from "axios";
import config from "../config";
import { mapState } from 'vuex'

export default {
  components: {
    SelectInput,
    TextInput,
    ShortFields,
    DateInput,
    NumberInput,
    EmailInput,
    CheckboxInput,
    FormBtn
},
  mixins: [FormTitles],
  props:{
    hideCondition: {type: Boolean, required: true},
    validationEnabled: {type: Boolean, default: true}
  },
  data: ()=>({
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    DaDataUrlAddress: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    DaDataUrlFIO: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
    block: false,
    fieldsStatus: {
      fullname: false,
      phonenumber: false,
      email: false,
      birthdate: false,
      birthplace: false,
      'p-series': false,
      'p-number': false,
      'p-releasedate': false,
      address: false,
      noflat: false,
      agreement: false
    },
    client: {
      fullname: '',
      phonenumber: '',
      email: '',
      sex: '',
      birthdate: '',
      birthplace: '',
      passport: {
        series: '',
        number: '',
        releasedate: ''
      },
      address: {
        text: '',
        city_kladr_id: '',  
        street_kladr_id: '',
        house_kladr_id: '',
        index: '',
        flat: '',
        house: '',
        block: '',
        block_type: '',
        noflat: false,
      },
      isAgree: false
    },
    suggestionsData: {},
    validations: {
      birthdate: (date)=> {
        if (Date.now() - date < 0)
          return 'Указана дата из будущего'
        let y = new Date().getFullYear(),
            m = new Date().getMonth(),
            d = new Date().getDate()
        if (date > new Date(y-18, m, d))
          return 'Страхователь должен быть совершеннолетним'
        if (date < new Date(y-69, m, d))
          return 'Не может быть больше 69 лет'
        return ''
      },
      releasedate: (date)=> {
        if (Date.now() - date < 0)
          return 'Указана дата из будущего'
        let y = new Date().getFullYear(),
            m = new Date().getMonth(),
            d = new Date().getDate()
        if (date < new Date(y-69, m, d))
          return 'Не может быть больше 69 лет'
        return ''
      }
    }
  }),
  methods: {
    sendForm(){
      document.dispatchEvent(new Event('ym-polis_2'))

      let vm = this;
      vm.block = true;
      vm.$store.commit('setLoading', true)
      axios.post(config.apiPath + config.path.sendInfo, {
        formData: vm.client,
        selectedProgram: vm.selectedProgram,
      }).then(response => {
        vm.$store.commit('setLoading', false)

        if( response.data.status !== undefined && response.data.status === "OK" && response.data.guid !== undefined) {
          let urlSample = 'https://rosbankinsurance.ru/max_protection_online/index_pay_api.php?action=getFile&guid=' + response.data.guid
          vm.$store.commit('customErrorText', [])
          vm.$store.commit('setSampleUrl', urlSample)
          vm.$store.commit('setClient', vm.client)
          vm.$store.commit('nextStep')
          vm.block = false;
        }
        else if(response.data.status !== undefined && response.data.status === "ERROR"){
          vm.$store.commit('customErrorText',  response.data.messages)
          vm.$store.commit('throwError')
          vm.block = false;
        }
        else{
          vm.$store.commit('customErrorText', [])
          vm.$store.commit('throwError')
          vm.block = false;
        }
      }).catch(()=> {
        vm.$store.commit('setLoading', false)
        vm.$store.commit('customErrorText', [])
        vm.$store.commit('throwError')
        vm.block = false;
      });

      document.dispatchEvent(new Event('ym-obrazec'))
    }
  },
  computed: {
    ...mapState(['programs']),
    selectedProgram: {
      get() {
        return this.$store.state.selectedProgram
      },
      set(val) {
        this.$store.commit('setSelectedProgram', val)
      }
    },
    allFilled(){
      if (this.programIndex > 0)      
        if (!this.client.address.house || (!this.client.address.noflat && !this.client.address.flat))
          return false

      let res = true
      let exceptions = ['address','noflat']
      for (let i in this.fieldsStatus) {
        if (exceptions.includes(i) && this.programIndex <= 0)
          continue
        res = res * this.fieldsStatus[i]
      }

      return res
    },
    programIndex(){
      return this.programs.indexOf(this.selectedProgram)
    },
    address(){
      return this.client.address.text
    },
    addressValidation(){
      if (!this.client.address.text)
        return ''
      if (!this.client.address.house)
        return 'Укажите полный адрес'
      if (!this.client.address.noflat && !this.client.address.flat)
        return 'Укажите квартиру'      
      return ''
    }
  },
  asyncComputed:{
    async fullnameSuggest(){
      let url = this.DaDataUrlFIO,
          token = this.DaDataToken,
          query =  this.client.fullname,
          gender = 'UNKNOWN'
      switch(this.client.sex) {
        case 'Мужской':
          gender = 'MALE'
          break
        case 'Женский':
          gender = 'FEMALE'
      }
      let  options =  {
          method: "POST",
          mode: "cors",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": "Token " + token
          },
          body: JSON.stringify({ query, gender, count: 5 })
        }
        
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=>{return res.suggestions.map(el=>((el.data.surname || '') + ' ' + (el.data.name || '') + ' ' + (el.data.patronymic || '')).replace(/\s+/g, ' ').trim())})
                        .catch(()=>[]))
                      
      return sg
    },
    async birthplaceSuggest(){
      let url = this.DaDataUrlAddress,
          token = this.DaDataToken,
          query =  this.client.birthplace,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query, count: 5,
                  "locations": [{"country": "*"}],
                  "to_bound": { "value": "settlement" },})
          }
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=>{ return res.suggestions.map(el=>el.value)})
                        .catch(()=>[]))
      return sg
    },
    async addressSuggest(){
      let url = this.DaDataUrlAddress,
          token = this.DaDataToken,
          query =  this.client.address.text,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query, count: 5,
                  "locations": [{"country": "Россия"}]})
          }
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=> res.suggestions.filter(el=>el.data))
                        .catch(()=>[]))
      this.suggestionsData = sg
      return sg.map(el=>el.value)
    }
  },
  watch: {
    address(val){
      this.client.address.city_kladr_id = ''
      this.client.address.street_kladr_id = ''
      this.client.address.house_kladr_id = ''
      this.client.address.index = ''
      this.client.address.flat = ''
      this.client.address.house = ''
      this.client.address.block = ''
      this.client.address.block_type = ''
      if (val && this.suggestionsData) {
        let found = this.suggestionsData.find(el=>el.value == val)
        if (!found) return
        this.client.address.city_kladr_id = found.data.city_kladr_id || found.data.settlement_kladr_id
        this.client.address.street_kladr_id = found.data.street_kladr_id
        this.client.address.house_kladr_id = found.data.house_kladr_id
        this.client.address.flat = found.data.flat
        this.client.address.house = found.data.house
        this.client.address.index = found.data.postal_code
        this.client.address.block = found.data.block
        this.client.address.block_type = found.data.block_type
      }
    }
  }
}
</script>

<style>

</style>